module.exports = __webpack_public_path__ + "static/media/mike.8d9bbf30.jpg";